module.exports = __webpack_public_path__ + "img/background-legend.e7dd34fa.svg";